export const TRANSACTION_LIST_SUCCESS = 'TRANSACTION_LIST_SUCCESS';
export const TRANSACTION_LIST_ERROR = 'TRANSACTION_LIST_ERROR';
export const TRANSACTION_CLEAR_ALL = 'TRANSACTION_CLEAR_ALL';
export const SET_CONVERSATION_ACTIVE_STATUS = 'SET_CONVERSATION_ACTIVE_STATUS';
